import { type ChangeEvent, type KeyboardEvent, useCallback, useState } from 'react'

export interface UseRedeemCodeInputReturn {
  code: string
  isValidCode: boolean
  handleCodeChange: (e: ChangeEvent<HTMLInputElement>) => void
  handleKeyDown: (e: KeyboardEvent<HTMLInputElement>, onSubmit: () => void) => void
  resetCode: () => void
}

export const useRedeemCodeInput = (): UseRedeemCodeInputReturn => {
  const [code, setCode] = useState('')

  const handleCodeChange = useCallback((e: ChangeEvent<HTMLInputElement>): void => {
    setCode(e.target.value.toUpperCase())
  }, [])

  const handleKeyDown = useCallback(
    (e: KeyboardEvent<HTMLInputElement>, onSubmit: () => void): void => {
      if (e.key === 'Enter' && code.trim()) {
        onSubmit()
      }
    },
    [code]
  )

  const resetCode = useCallback((): void => {
    setCode('')
  }, [])

  return {
    code,
    isValidCode: code.trim().length > 0,
    handleCodeChange,
    handleKeyDown,
    resetCode,
  }
}
